import { Injectable ,InjectionToken} from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { IAppConfig } from '../../Model/config.model'
import data from 'src/assets/config/config.json';
import { Observable } from 'rxjs';




@Injectable()


export class ConfigLoaderService {
  // public environment = "";
  // //For testing Purpose
  // public projectId = '';
  // public apiURL = "";

  // public copyRight = "";
  // public hanaLink = "";
  // public eccLink = "";
  // public bwLink = "";
  // public apoLink = "";
  // public srmLink = "";
  // public utilitiesLink = "";
  // public upstreamLink = "";
  // public downstreamLink = "";
  // public demoLink = '';


 
  private http: HttpClient;
  static settings: IAppConfig;
  public appsetting!:any[];
  private endpoint!:string;

  public clientId!:string;

  constructor(
    private httpClient: HttpClient,
    private readonly httpHandler: HttpBackend,
    ) {
    this.http = new HttpClient(httpHandler);
    
  }



  initialize() {
    return this.httpClient.get<IAppConfig>('./assets/config/config.json')
      .pipe(tap((response: IAppConfig) => { 
        this.clientId=response.adalConfig.clientId;
        ConfigLoaderService.settings =<IAppConfig>response;
        console.log(ConfigLoaderService.settings)
      })).toPromise<IAppConfig>();
  }


  init(endpoint:string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.http.get(endpoint).pipe(map(res => res))
        .subscribe((value:any) => { 
          this.appsetting=value["adalConfig"];
          ConfigLoaderService.settings =<IAppConfig>value;
          resolve(true);
        },
          (error) => {
            reject(error);
          });
       
    });
  }

  getSettings(key?: string | Array<string>, configValues?:any): any {
  
  
    if (!key || (Array.isArray(key) && !key[0])) {
     
      return this.appsetting;
    }
    if (!Array.isArray(key)) {
      key = key.split('.');
      
    }

    // if(this.appsetting=="undefined" ||this.appsetting==undefined){
    //   console.log('hereh11')
    //   this.endpoint='./assets/config/config.json';
    //   this.http.get(this.endpoint).pipe(map(res => res))
    //     .subscribe(value => {  
    //      // adalConfigValue=value;
    //      console.log('hhhhh')
    //       this.appsetting=value
    //     });

    // }
 
   
     
    
     let result = key.reduce((acc: any, current: string) => acc && acc[current], this.appsetting);
    // console.log(result);
    return result;
  }


  getConfiguration() {
    return this.httpClient.get('./assets/config/config.json')
    }
}
  






